import { useTranslation } from 'react-i18next';

import useFetchBookingDotComPropertyScores from 'components/domain/bookingDotCom/useFetchBookingDotComPropertyScores';
import LoadingPlaceholder from 'components/loader/LoadingPlaceholder';
import { GetPropertyScoresResponseTO as GetBookingDotComPropertyScoresResponseTO } from 'models/bookingDotCom/PropertyScore';
import usePropertyUidForQualityScore from './usePropertyUidForQualityScore';

interface BookingDotComQualityScoreTabHeaderProps {
  category: keyof GetBookingDotComPropertyScoresResponseTO;
}

const BookingDotComQualityScoreTabHeader = ({
  category,
}: BookingDotComQualityScoreTabHeaderProps) => {
  const { t } = useTranslation();
  const propertyUid = usePropertyUidForQualityScore();
  const { data: propertyScores, isLoading } =
    useFetchBookingDotComPropertyScores({ propertyUid });

  const title = t('pageProperty.reviews.bookingDotCom.tabName', {
    context: category,
  });

  if (isLoading) {
    return (
      <div className="rating-category">
        <span>{title}</span>
        <LoadingPlaceholder />
      </div>
    );
  }

  return (
    <div className="rating-category" data-testid={`category-score-${category}`}>
      <span>{title}</span>
      <span>{propertyScores?.[category].score ?? '-'}</span>
    </div>
  );
};

export default BookingDotComQualityScoreTabHeader;
